import axios from 'axios';
import API from '../Api';

export function getTransactionDetails(params) {
    return axios.get(API.GET_TRANSACTION_DETAILS, params)
}

export function updateDeliveryStatus(params) {
    return axios.post(API.UPDATE_DELIVERY_STATUS, params)
}